module.exports={
    title:'The contract quantification robot is safe, convenient and efficient, making transactions more secure.',
    ul_li1:'contact customer',
    ul_li2:'Help center',
    ul_li2_phone:'Help',
    ul_li3:'OKX registered address',
    ul_li4:'Terms of service',
    ul_li4_phone:'Service',
    download_app: 'Download App',
    send: 'Send',
    feedback: 'Feedback',
    select_question_type: 'Select the question type',
    problem_description: 'Problem description',
    please_enter_content: 'Please enter the content',
    add_photo: 'Add photo',
    submit: 'submit',
    scan_qr_code: 'Scan the QR code to download',
    ios_coming_soon: 'iOS is coming soon',
    complain: 'Complain',
    suggestion: 'Suggestion',
    fault: 'Fault',
    other:'Other',
    content_yet:'No content yet',
    fee_exemption:'The fuel fee exemption policy is about to expire',
    live_broadcast:'UPLUS live broadcast'
}
